"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pickers_1 = require("@material-ui/pickers");
var moment_1 = __importDefault(require("@date-io/moment"));
var moment_2 = __importDefault(require("moment"));
var react_1 = __importDefault(require("react"));
var DateInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, disabled = _a.disabled, className = _a.className, minDate = _a.minDate, maxDate = _a.maxDate, error = _a.error, helperText = _a.helperText;
    var momentValue = value ? new Date(value) : null;
    return (react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, { utils: moment_1.default },
        react_1.default.createElement(pickers_1.KeyboardDatePicker, { error: error, helperText: helperText, minDate: minDate, maxDate: maxDate, className: className, disabled: disabled, clearable: true, value: momentValue, placeholder: 'DD-MM-YYYY', onChange: function (_, value) {
                var momentValue = moment_2.default.utc(value, 'DD-MM-YYYY', true);
                var valid = momentValue.isValid();
                if (valid) {
                    onChange === null || onChange === void 0 ? void 0 : onChange(momentValue.toISOString());
                }
                else {
                    onChange === null || onChange === void 0 ? void 0 : onChange(value);
                }
            }, format: 'DD-MM-YYYY' })));
};
exports.default = DateInput;
//# sourceMappingURL=DateInput.js.map